import { render, staticRenderFns } from "./EpochSelectorItem.vue?vue&type=template&id=d22deff8&"
import script from "./EpochSelectorItem.vue?vue&type=script&lang=js&"
export * from "./EpochSelectorItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports